/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Nav_Domain_PricingInputs */

const id_staff_nav_domain_pricing = /** @type {(inputs: Staff_Nav_Domain_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga domain`)
};

const en_staff_nav_domain_pricing = /** @type {(inputs: Staff_Nav_Domain_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain pricing`)
};

/**
* | output |
* | --- |
* | "Domain pricing" |
*
* @param {Staff_Nav_Domain_PricingInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_nav_domain_pricing = /** @type {((inputs?: Staff_Nav_Domain_PricingInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Nav_Domain_PricingInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_nav_domain_pricing(inputs)
	return id_staff_nav_domain_pricing(inputs)
});